import { render, staticRenderFns } from "./CarouselsImage.vue?vue&type=template&id=1de41e6b&scoped=true&"
import script from "./CarouselsImage.vue?vue&type=script&lang=js&"
export * from "./CarouselsImage.vue?vue&type=script&lang=js&"
import style0 from "./CarouselsImage.vue?vue&type=style&index=0&id=1de41e6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de41e6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VIcon,VImg,VLayout,VOverlay,VSlideGroup,VSlideItem})
